
import store from '../../src/store/store';
import AuthService from '../../src/services/AuthService';
import axios from 'axios';
import GO1_API from '../../src/config/api'

export default {

    // get email body
    getBody () {
        return `They have ${store.state.users_total} users on their Totara Instance and their Totara License is ${store.state.totara_license}.`;
    },

    // get email subject
    getSubject () {
        return `${store.state.customer_partner} just created a new GO1 Portal!`;
    },

    // send email to internal department to notify of new user onboarding
    notify () {

        const emailBody = {
            body: this.getBody(),
            subject: this.getSubject(),
            application: "website",
            department: "INBOUND"
        }

        const url = `${GO1_API}mail`;
        axios.post(url, emailBody, AuthService.getAPIAuthConfig())
    }
}


// WEBPACK FOOTER //
// ./src/services/MailService.js